import { useQuery } from '@tanstack/react-query'
import type { CountryList } from '@mobi/api-types'
import { SignUpUrl, get, queryKeys } from '../../../Utils'

export const useCountryList = () => {
  return useQuery<CountryList>({
    queryKey: queryKeys.accountCountryList,
    queryFn: getCountryList,
    staleTime: 360000,
    refetchOnWindowFocus: false,
  })
}

export function getCountryList() {
  return get<CountryList>(SignUpUrl.countryList)
}
